export default {
  apiEndpoint: '/api/v1.0',
  imageEndpoint: '',
  siteURL: 'https://thitructuyenddsh.com/',
  recaptchaSiteKey: '6LdkktctAAAAABuiC7FiVRn4Q05aImDPAli3DcvE',
  pageSpeedUserAgent:
    /(Mozilla\/5\.0 \(Linux; Android 11; moto g power \(2022\)\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/109\.0.0.0 Mobile Safari\/537\.36)|(Mozilla\/5\.0 \(Macintosh; Intel Mac OS X 10_15_7\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/109\.0\.0\.0 Safari\/537\.36)|(Speed Insights)|(Chrome-Lighthouse)|(PSTS[\d.]+)/
}
